(function (a, b, c, d) {
    var regRbs = /.*rbs\.co.uk$/;
    var regNw = /.*natwest\.com$/;
    var isProdRbs = regRbs.test(window.location.hostname);
    var isProdNw = regNw.test(window.location.hostname);
    var isProd = false;
    if (isProdRbs || isProdNw) {
        isProd = true;
    }
  var isPreProd = window.location.hostname.indexOf('prod.dlgdigitalapi') > -1;
  var tealiumScript = document.createElement('script');
  tealiumScript.type = 'text/javascript';
  tealiumScript.async = false;
  tealiumScript.src = 'https://tags.tiqcdn.com/utag/dlg/bp-rbs-group/' + (isPreProd ? 'preprod' : (isProd ? 'prod' : 'dev')) + '/utag.sync.js';
  document.head.appendChild(tealiumScript);
})();
